import * as z from "zod";
import { userFacingError } from "../authorization";
import { dropConnectorUsage, usageRef } from "../connectorUsages";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const dissociatePersonalChatFromConnectedApp = mutator({
  schema: z.object({
    personalChatId: z.string(),
    connectedAppId: z.string(),
  }),
  resolve: {},
  permissions: {
    none: "drops a connector usage ref for the caller’s own personal chat; ownership is checked in fn",
  },
  fn: async ({ tx, ctx, args: { personalChatId, connectedAppId } }) => {
    const [pc] = await tx.run(
      zql.personalChats
        .where("deletedAt", "IS", null)
        .where("id", personalChatId)
        .where("userId", ctx.userId)
    );
    if (!pc) throw userFacingError("Personal chat not found");

    await dropConnectorUsage(
      tx,
      connectedAppId,
      usageRef.personalChat(personalChatId)
    );
  },
});
